import React, { Fragment, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { Table } from "reactstrap";
import ViewChangeHistoryModal from './modal-in-modal/view-change-history';
import getTitle from '../../../../../utilities/getTitle';
import TicketHistory from '../../../../requests/modal/TicketHistory';
import PolicyCancellationRequestModal from '../../../../requests/modal/policy-cancellation-request-modal';
import PolicyEditRequestModal from '../../../../requests/modal/policy-edit-request-modal';
import formatedDate from '../../../../../utilities/formatedDate';


const ChangeHistoryDetails = (props) => {

    const { data } = props;
    const [viewChangeHistoryModal, setViewChangeHistoryModal] = useState(false);
    const toggleViewChangeHistoryModal = () => setViewChangeHistoryModal(!viewChangeHistoryModal);
    const [ticketsHistory, setTicketsHistory] = useState(data?.tickets);
    const [dealerData, setDealerData] = useState(data?.dealer);
    const [rowData, setData] = useState({});

    const [policyEditRequestModal, setPolicyEditRequestModal] = useState(false);
    const [policyCancellationRequestModal, setPolicyCancellationRequestModal] = useState(false);
    const [commonTicketModal, setCommonTicketModal] = useState(false);

    const togglePolicyCancellationRequestModal = () => setPolicyCancellationRequestModal(!policyCancellationRequestModal);
    const togglePolicyEditRequestModal = () => setPolicyEditRequestModal(!policyEditRequestModal);
    const toggleCommonTicketModal = () => setCommonTicketModal(!commonTicketModal);
    const [ticketHistory, setTicketHistory] = useState(false);
    const [ticketData, setTicketData] = useState({});
    const toggleTicketHistory = () => setTicketHistory(!ticketHistory);
    const viewTypeToggle = (e, row) => {
        row.dealership = dealerData;
        row.fromPolicy = true;
        setData(row);
        const type = row.type;
        if (type === "POLICY_CANCEL" || type === "POLICY_CANCEL_DIRECT" || type === "CASHIFY_POLICY_CANCEL" || type === "CASHIFY_POLICY_EDIT") {
            togglePolicyCancellationRequestModal();
        } else if (type === "DOCUMENT_EDIT" || type === "POLICY_EDIT_DIRECT") {
            togglePolicyEditRequestModal();
        } else {
            toggleCommonTicketModal();
        }
    };

    const viewHistory = (e, row, type) => {
        if (type === "HISTORY") {
            //   console.log(row, "row data");
            setTicketData(row);
            toggleTicketHistory();
        }
    };
    console.log("data in change history this is ", data);
    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" className='pad-l-r-40 pad-b-0'>
                    <Row>
                        <Col sm="12">

                            <Table >
                                <thead>
                                    <tr>
                                        <th>{"Ticket Id"}</th>
                                        <th>{"Type"}</th>
                                        <th>{"Requested By"}</th>
                                        {/* <th>{"Reason"}</th>
                                        <th>{"Remark"}</th> */}
                                        <th>{"Date created"}</th>
                                        <th>{"Status"}</th>
                                        {/* <th>{"History"}</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 && data.map((item, i) => {

                                        let badgeClass = "";
                                        switch (item?.status?.toLowerCase()) {
                                            case "initiated":
                                                badgeClass = "badge badge-primary";
                                                break;
                                            case "in transit":
                                                badgeClass = "badge badge-warning";
                                                break;
                                            case "approved":
                                                badgeClass = "badge badge-success";
                                                break;
                                            case "rejected":
                                                badgeClass = "badge badge-danger";
                                                break;
                                            default:
                                                break;
                                        }

                                        return (
                                            <tr>
                                                <td>
                                                    <a
                                                        style={{
                                                            color: "blue",
                                                            cursor: "pointer",
                                                            textDecoration: "underline",
                                                        }}
                                                        onClick={(e) => viewTypeToggle(e, item)}
                                                        className="link"
                                                    >
                                                        {item?.ticketNumber || "N/A"}{" "}
                                                    </a>
                                                </td>
                                                <td>

                                                    {getTitle(item?.type) || data.policyStatus}

                                                </td>
                                                <td>
                                                    {item?.created_by_name || data.cancelledBy}

                                                </td>
                                                {/* <td>
                                                    {item?.created_reason}
                                                </td>
                                                <td>
                                                    {item?.created_remark}
                                                </td> */}
                                                <td>
                                                    {formatedDate(item?.create_at)}
                                                </td>
                                                <td>

                                                    <span className={badgeClass}>
                                                        {item?.status?.toUpperCase() || data.policyStatus}

                                                    </span>

                                                </td>

                                                {/* <td>

                                                    <span onClick={(e) => viewHistory(e, item, "HISTORY")} style={{display:"none"}}>
                                                        <Button color="warning" size="xs">
                                                            <span style={{ color: 'black' }}> <i class="fa fa-history" aria-hidden="true"></i> History</span>
                                                        </Button>
                                                    </span>
                                                </td> */}

                                            </tr>

                                        )
                                    })

                                    }
                                </tbody>
                            </Table>

                        </Col>
                    </Row>
                </Col>
            </Row>

            {/* <ViewChangeHistoryModal isOpen={viewChangeHistoryModal} toggle={toggleViewChangeHistoryModal} data={data} changeNewHistory={changeNewHistory} changeExistingHistory={changeExistingHistory} mappingFuel={mappingFuel} mappingTransmission={mappingTransmission} model={model} variant={variant} /> */}
            {ticketHistory && (
                <TicketHistory
                    isOpen={ticketHistory}
                    toggle={toggleTicketHistory}
                    data={ticketData}
                />
            )}

            {policyCancellationRequestModal && (<PolicyCancellationRequestModal
                isOpen={policyCancellationRequestModal}
                toggle={togglePolicyCancellationRequestModal}
                rowData={rowData}
            />)}

            {policyEditRequestModal && (
                <PolicyEditRequestModal
                    isOpen={policyEditRequestModal}
                    toggle={togglePolicyEditRequestModal}
                    rowData={rowData}
                    isHistoryTabTrigger={props.isHistoryTabTrigger}
                />)}
        </Fragment>
    );
};

export default ChangeHistoryDetails;